import { z } from "zod";
import { optional } from "./appointments";
import { recordId } from "./contracts";
import { unset } from "./fields";
import { paymentRecipient } from "./payment-dues";

export const PAYOUT_PAGE_SIZE_MAX = 100;

export const payoutReadQuery = z.object({ actingOrganization: optional(recordId.toLowerCase()) });
export type PayoutReadQuery = z.infer<typeof payoutReadQuery>;

export const payoutListQuery = payoutReadQuery.extend({
  payer: optional(recordId.toLowerCase()),
  recipient: optional(recordId.toLowerCase()),
  page: z.preprocess(unset, z.coerce.number().int().min(1).max(10_000).default(1)),
  pageSize: z.preprocess(unset, z.coerce.number().int().min(1).max(PAYOUT_PAGE_SIZE_MAX).default(25)),
});
export type PayoutListQuery = z.infer<typeof payoutListQuery>;

export const payoutStatus = z.enum(["pending", "paid", "failed"]);
export type PayoutStatus = z.infer<typeof payoutStatus>;

export const payoutMethod = z.enum(["stripe", "byHand"]);
export type PayoutMethod = z.infer<typeof payoutMethod>;

export const payout = z.object({
  id: recordId,
  payer: z.object({ id: recordId, name: z.string() }),
  recipient: paymentRecipient,
  amount: z.number(),
  currency: z.string(),
  status: payoutStatus,
  method: payoutMethod,
  extra: z.boolean(),
  createdAt: z.string().datetime({ offset: true }),
});
export type Payout = z.infer<typeof payout>;

export const payoutPage = z.object({ items: z.array(payout), total: z.number().int().nonnegative() });
export type PayoutPage = z.infer<typeof payoutPage>;
